import styled from 'styled-components';
import { Input, Select } from 'antd';

const { TextArea } = Input;

export const StyledCpscCoreFormDiv = styled.div`
  .radio-group-horizontal .ant-radio-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }

  .radio-group-horizontal .ant-radio-wrapper {
    display: flex;
    align-items: center;
    margin-right: ${({ theme }) => theme.spacing.space_4};
    white-space: nowrap;
  }
`;

export const StyledRootFieldsDiv = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-top: ${({ theme }) => theme.spacing.space_5};
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
`;

export const StyledDiv = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-top: ${({ theme }) => theme.spacing.space_3};
  margin-bottom: -${({ theme }) => theme.spacing.space_3};
`;

export const StyledSelect = styled(Select)`
  display: block;
  margin-top: ${({ theme }) => theme.spacing.space_2};

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
  }
`;

export const StyledInput = styled(Input)`
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledAddonSelect = styled(Select)`
  width: ${({ theme }) => theme.size.micro_tiny};
  display: flex;
  flex-direction: row;

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
    padding-right: ${({ theme }) => theme.spacing.space_2} !important;
    padding-left: ${({ theme }) => theme.spacing.space_2} !important;
  }
`;

export const StyledFlexDiv = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  align-items: flex-start;
`;

export const StyledTextArea = styled(TextArea)`
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledDeclaration = styled.div`
  margin-top: ${({ theme }) => theme.spacing.space_4};
  padding: ${({ theme }) => theme.spacing.space_3};
  border: ${({ theme }) => theme.spacing.space_1} solid
    ${({ theme }) => theme.palette.neutrals.summit};
  border-radius: ${({ theme }) => theme.spacing.space_2};

  .ant-checkbox-wrapper {
    align-items: flex-start;

    .ant-checkbox {
      margin-top: ${({ theme }) => theme.spacing.space_1};
    }
  }

  .declaration-text {
    line-height: 1.5;
  }
`;
